/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_P1Inputs */

const tr_mesafeli_s6_p1 = /** @type {(inputs: Mesafeli_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik, Müşteri'nin seçtiği süre için (aylık plan 30 gün, yıllık plan 365 gün) peşin ödeme karşılığında kurulur ve süre sonunda kendiliğinden sona erer. Abonelik otomatik olarak yenilenmez. 6502 sayılı Kanun ve Abonelik Sözleşmeleri Yönetmeliği'nin belirli süreli sözleşmelere ilişkin emredici hükümleri saklıdır.`)
};

const en_mesafeli_s6_p1 = /** @type {(inputs: Mesafeli_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subscription is established for the term chosen by the Customer (monthly plan 30 days, yearly plan 365 days) against advance payment and ends by itself at the end of the term. The Subscription does not renew automatically. The mandatory provisions of Law No. 6502 and the Abonelik Sözleşmeleri Yönetmeliği (Subscription Agreements Regulation) on fixed-term agreements remain reserved.`)
};

const de_mesafeli_s6_p1 = /** @type {(inputs: Mesafeli_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Abonnement wird für die vom Kunden gewählte Laufzeit (Monatstarif 30 Tage, Jahrestarif 365 Tage) gegen Vorauszahlung geschlossen und endet mit Ablauf der Laufzeit von selbst. Es verlängert sich nicht automatisch. Die zwingenden Vorschriften des Gesetzes Nr. 6502 und der Abonelik Sözleşmeleri Yönetmeliği (Verordnung über Abonnementverträge) für befristete Verträge bleiben unberührt.`)
};

const ru_mesafeli_s6_p1 = /** @type {(inputs: Mesafeli_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка оформляется на выбранный Клиентом срок (месячный тариф 30 дней, годовой тариф 365 дней) с предоплатой и по окончании срока прекращается сама. Подписка не продлевается автоматически. Императивные нормы Закона № 6502 и Abonelik Sözleşmeleri Yönetmeliği (Положение о договорах подписки) в отношении срочных договоров сохраняют силу.`)
};

/**
* | output |
* | --- |
* | "The subscription is established for the term chosen by the Customer (monthly plan 30 days, yearly plan 365 days) against advance payment and ends by itself a..." |
*
* @param {Mesafeli_S6_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_p1 = /** @type {((inputs?: Mesafeli_S6_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_p1(inputs)
	if (locale === "de") return de_mesafeli_s6_p1(inputs)
	if (locale === "ru") return ru_mesafeli_s6_p1(inputs)
	return tr_mesafeli_s6_p1(inputs)
});